import axios from "../../../../services/axiosInstance";

export function getTrophies(queryParams) {
  return axios.get("user-trophies", { params: queryParams });
}
